"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = HeroBanner;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = require("@chakra-ui/react");
var _utils = require("@whitbread-eos/utils");
var _image = _interopRequireDefault(require("next/image"));
var _jsxRuntime = require("react/jsx-runtime");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function HeroBanner(_ref) {
  var {
    title,
    image
  } = _ref;
  return (0, _jsxRuntime.jsxs)(_react.Flex, _objectSpread(_objectSpread({}, styles.wrapper), {}, {
    children: [(0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, styles.imageContainer), {}, {
      children: (0, _jsxRuntime.jsx)(_image.default, {
        src: (0, _utils.formatAssetsUrl)(image),
        alt: title,
        fill: true,
        style: {
          objectFit: 'cover'
        },
        "data-testid": "HeroBanner-Image"
      })
    })), (0, _jsxRuntime.jsx)(_react.Box, _objectSpread(_objectSpread({}, styles.contentContainer), {}, {
      children: (0, _jsxRuntime.jsx)(_react.Heading, _objectSpread(_objectSpread({
        as: "h1"
      }, styles.title), {}, {
        "data-testid": "HeroBanner-Title",
        children: title
      }))
    }))]
  }));
}
var styles = {
  wrapper: {
    position: 'relative',
    width: '100vw',
    minWidth: '100%',
    left: '50%',
    transform: 'translateX(-50%)',
    height: {
      base: '180px',
      md: '224px'
    },
    align: 'center',
    justify: 'center',
    overflow: 'hidden',
    borderRadius: 0,
    mt: '-0.5rem'
  },
  imageContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    zIndex: 0
  },
  contentContainer: {
    position: 'relative',
    zIndex: 1,
    width: 'full',
    maxW: '1228px',
    display: 'flex',
    alignItems: 'center',
    px: {
      base: '4',
      lg: '0'
    }
  },
  title: {
    color: 'white',
    fontSize: {
      base: '1.8rem',
      md: '2.5rem'
    },
    fontWeight: '900',
    textAlign: 'left',
    textShadow: '0 2px 8px rgba(0,0,0,0.5)'
  }
};